import Vue from 'vue'
import { Upload } from 'buefy'
// import 'buefy/dist/buefy.css'

Vue.use(Upload)
